import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-new-modal',
    templateUrl: './new-modal.component.html',
    styleUrls: ['./new-modal.component.scss'],
    standalone: false
})
export class NewModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
